// extracted by mini-css-extract-plugin
export var editInput = "_gs-0";
export var editInputCompact = "_gs-2";
export var editInputLarge = "_gs-1";
export var editInputSmall = "_gs-3";